import { fetchApi } from "./apiCalls"


const handleDpiBlur = async (e, setModal, setIsGrid, contadorDPI, setContadorDPI, url, headers) => {
    let res
 
    try { 

        res = await fetchApi({
            url: url + '/utils/cliente_cui',
            headers,
            content: {
                Cui: e.target.value
            }
        })
        return res
        //console.log('RES: ', res.msg)

    } catch (err) {
        console.log(err)
        setModal({
            msg: 'Revisa tu numero de DPI / CUI, para continuar',
            ok: false,
            show: true
        })
        setIsGrid(0)
        /*
        if (contadorDPI <= 2) {
            setModal({
                msg: 'Revisa tu numero de DPI, para continuar',
                ok: false,
                show: true
            })
            setIsGrid(0)
        }
        setContadorDPI(contadorDPI + 1)
        */
    }
}

export {
    handleDpiBlur
}